<ion-header>

  <ion-toolbar>

    @if (videos && videos.length > 1) {

      <div class="progress-wrapper">

        @for (story of videos; track story; let index = $index) {

          <div class="progress-segment">

            <div
              class="progress-fill"
              [ngStyle]="{width: index < activeIndex ? '100%' : (index === activeIndex ? progress + '%' : '0%')}"
            ></div>

          </div>

        }

      </div>

    }

    <ion-buttons
      slot="end"
      [ngClass]="{'not-progress-bar': videos && videos.length <= 1}"
    >
      <yu-button type="clear" color="light" (yuClick)="exitViewer()">
        <yu-icon name="x"></yu-icon>
      </yu-button>
    </ion-buttons>

  </ion-toolbar>

</ion-header>

<ion-content [scrollY]="false">

  @for (story of videos; track story; let index = $index) {

    @if (index === activeIndex) {

      <div class="story-slide">

        <video
          #video
          autoplay
          playsinline
          preload="auto"
          [ngClass]="{'video-loading': isVideoLoading}"
          [src]="story.url"
          (loadedmetadata)="onVideoLoaded(video, index)"
          (canplay)="onVideoCanPlay(index)"
          (ended)="nextVideo()"
          (error)="onVideoError()"
        ></video>

        @if (isPaused) {

          <div class="pause-indicator">
            <yu-icon name="play"></yu-icon>
          </div>

        }

      </div>

    }

  }

  <div class="touch-zone">
    <div (click)="previousVideo()"></div>
    <div (click)="togglePlayPause()"></div>
    <div (click)="nextVideo()"></div>
  </div>

  <div class="controls-container">

    <ion-range
      class="progress-slider"
      color="light"
      [min]="0"
      [max]="100"
      [value]="progress"
      (ionChange)="onProgressChange($event)"
      (ionKnobMoveStart)="onProgressStart()"
      (ionKnobMoveEnd)="onProgressEnd()"
    ></ion-range>

  </div>

</ion-content>
